import { FILE_UPLOADING, FILE_LOADING_ERROR ,FILE_LOADING_DONE} from '../actions/types'

const initialState = {
    filesLoading: false, fileLoadingState: false
}

export default function (state = initialState, action) {

    switch (action.type) { //que me llega la cadena type para el switch y el payload en este caso 
        case FILE_UPLOADING:
            return { ...state, filesLoading: true }
        case FILE_LOADING_ERROR:
            return { ...state, filesLoading: false, fileLoadingState: false }
        case FILE_LOADING_DONE:
            return { ...state, filesLoading: false, fileLoadingState: true }
        default:
            return state
    }
}